module.exports = __webpack_public_path__ + "static/media/cleverchords_3.a3096f59.jpg";